import { useSettings } from "hooks";
import type { MerchantSettings } from "features/merchants/types";
import type { ECommerceSettingsStatusCassetteSetting } from "../ECommerceSettingsStatusCassette";

const useActiveStatus = () => {
     const { getSettings } = useSettings<MerchantSettings>();

    const { isActive } = getSettings();

    return Array.of<ECommerceSettingsStatusCassetteSetting>({
        name: 'Account Status',
        value: isActive
    });
};

export default useActiveStatus;
